import { fontsMetadata } from '@wix/fonts-data'

const stripQuotes = (str: string): string => {
	const trimmed = str.trim()
	if ((trimmed.startsWith("'") && trimmed.endsWith("'")) || (trimmed.startsWith('"') && trimmed.endsWith('"'))) {
		return trimmed.slice(1, -1)
	}
	return trimmed
}

export function getFontFamilyWithFallbacks(fontFamily: string): string {
	if (!fontFamily) {
		return ''
	}

	const cleanFontName = stripQuotes(fontFamily.replace(/\+/g, ' ')).toLowerCase()
	const [highestPriorityFont] = cleanFontName.split(',')
	const metaData = fontsMetadata[highestPriorityFont]
	if (!metaData) {
		return fontFamily
	}
	return [highestPriorityFont, metaData.fallbacks, metaData.genericFamily].filter((t) => t).join(',')
}
